import { useQuery } from '@apollo/client'
import { MeDocument } from '@lib/graphql/documents.generated'

export const useMe = () => {
  const { data, loading } = useQuery(MeDocument, { errorPolicy: 'ignore' })

  return { me: data?.me, loading }
}
